<template>
  <div >
    <v-tooltip bottom>
      <v-btn :disabled="!nota.item.pathPdf && !nota.item.pathPdfMotor" :class="[!nota.item.pathPdf && !nota.item.pathPdfMotor? 'c_disabled' : '']" slot="activator" dark icon small flat @click="getPdfById(nota.item._id, nota.item.pathPdf)">
        <v-icon class="material-icons">remove_red_eye</v-icon>
      </v-btn>
      <span> {{nota.item.pathPdf  || nota.item.pathPdfMotor ?'Visualizar PDF' : 'PDF ainda não disponível, Motor Fiscal está trabalhando nisso.'}}</span>
    </v-tooltip>
    <v-dialog v-if="nota.item.hasOwnProperty('pathPdf') && nota.item.pathPdf || nota.item.hasOwnProperty('pathPdfMotor') && nota.item.pathPdfMotor" @keydown.esc="dialog = false" v-model="dialog" fullscreen :lazy="true">
      <v-card>
        <v-card-title class="headline darkBlue" text-color="white" style="color: white;">
          PDF NFSE
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text id="tst">
          <iframe
            style="width: 100%; height: 90vh;"
            :src="'data:application/pdf;base64,'+encodeURIComponent(this.pdfB64)"
            frameborder="0"
          />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialog = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import NfseService from "@/domain/notas/nfse/NfseService";
export default {
  props: ["nota"],
  data() {
    return {
      dialog: false,
      pdfB64: undefined
    };
  },
  watch: {},
  computed: {},
  methods: {

    getPdfById: async function(id,motor = false) {
      this.pdfB64 = null;
       this.service = new NfseService(this.$http);
       this.pdfB64 = await this.service.getPdfById(id,motor)
      if (this.pdfB64 != null) {
        this.dialog = true;
      }
    }
  }
};
</script>
<style>
/* #tst {
  display: inline-block;
} */
#lista {
  padding: 20px;
}
#ico {
  color: grey !important;
  transition: color 1 linear;
}
#ico:hover {
  color: #01579b !important;
}
#ico.v-btn {
  margin: 2px 2px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_actions/btnVisualizar/btnNfse/BtnNFSe.vue